import React from "react";
import styles from "./HamburgerButton.module.scss";
import clsx from "clsx";

export default function HamburgerButton(props) {
    const { dark, ...rest } = props;
  return (
    <div
      className={clsx(styles.button__hamburger, dark && styles.dark)}
      {...rest}
    >
     <div />
     <div />
     <div />
    </div>
  );
}
